<template>
  <div :class="{ 'search-page-2025__header': searchPage2025UI }">
    <div :class="{ 'ui-dark': searchPageLegacyUI || !isSearchRepo }">
      <header
          role="banner"
          class="header position-relative text-body-dark"
          itemscope
          itemtype="http://www.schema.org/WPHeader"
      >
        <TheNavDesktop class="d-none d-lg-block" />
        <TheNavMobile class="d-block d-lg-none" />
      </header>
    </div>
    <AuthModalsWrapper />
  </div>
</template>

<script>
import searchPage2025Mixin from '@motionelements/core/src/components/mixins/search-page-2025.mixin.js';
import TheNavDesktop from '@motionelements/core/src/components/nav/TheNavBarDesktop.vue';
import TheNavMobile from './nav/TheNavBarMobile.vue';

export default {
  name: 'the-nav-bar',
  mixins: [searchPage2025Mixin],
  props: {
    isTransparent: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TheNavDesktop,
    TheNavMobile,
    AuthModalsWrapper: () => import('./auth/AuthModalsWrapper.vue'),
  },
  created() {
    if (this.isLoggedIn) {
      this.$store.dispatch('cart/getSummary');
    }
  },
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  left: 0;
  top: 0;
  z-index: 1021;
}
</style>
